import type { HTMLAttributes, ReactNode } from "react";
import { createStyles } from "./styling";
import { LiquidGlass } from "./LiquidGlass";

const useStyles = createStyles(({ css, token }) => ({
  toolbar: css`
    align-items: center;
    background: var(--ark-fx-surface, ${token.colorBgContainer});
    backdrop-filter: var(--ark-fx-filter, none);
    border-bottom: 1px solid ${token.colorBorderSecondary};
    display: flex;
    flex: 0 0 50px;
    gap: 8px;
    height: 50px;
    min-width: 0;
    overflow: hidden;
    padding: 0 14px;

    @media (max-width: ${token.screenSMMax}px) {
      gap: 4px;
      padding: 0 max(8px, env(safe-area-inset-right)) 0
        max(8px, env(safe-area-inset-left));
    }
  `,
  leading: css`
    align-items: center;
    display: flex;
    flex: none;
    gap: 8px;
  `,
  title: css`
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    min-width: 96px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: ${token.screenSMMax}px) {
      min-width: 0;
    }
  `,
  actions: css`
    align-items: center;
    display: flex;
    flex: 0 1 auto;
    gap: 4px;
    min-width: 0;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: ${token.screenSMMax}px) {
      flex: none;
      max-width: 68%;
    }
  `,
}));

export function StandaloneToolbar({
  actions,
  children,
  className,
  leading,
  title,
  ...props
}: Omit<HTMLAttributes<HTMLElement>, "title"> & {
  actions?: ReactNode;
  leading?: ReactNode;
  title?: ReactNode;
}) {
  const { cx, styles } = useStyles();
  return (
    <LiquidGlass as="header" className={cx(styles.toolbar, "ark-glass-bar", className)} {...props}>
      {leading ? <div className={styles.leading}>{leading}</div> : null}
      <div className={styles.title}>{title ?? children}</div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </LiquidGlass>
  );
}
